import { render, staticRenderFns } from "./03-BuildingType.vue?vue&type=template&id=46b4d70a&scoped=true&"
import script from "./03-BuildingType.vue?vue&type=script&lang=js&"
export * from "./03-BuildingType.vue?vue&type=script&lang=js&"
import style0 from "./03-BuildingType.vue?vue&type=style&index=0&id=46b4d70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b4d70a",
  null
  
)

/* custom blocks */
import block0 from "./03-BuildingType.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports